import axios from 'axios';
import {getApiBaseUrl} from '../utils/getApiBaseUrl';
import secureStorage from "../utils/secureStorage";

// URL base de la API
const API_URL = getApiBaseUrl();
// const API_URL = getApiBaseUrl();


// Crear una instancia de Axios
const api = axios.create({
  baseURL: API_URL,
});

// Configurar un interceptor para agregar el token a cada solicitud
api.interceptors.request.use(
  (config) => {
    // Obtener el token del localStorage
    const token = secureStorage.getItem('authToken');
    
    if (token) {
      // Agregar el token al encabezado de autorización
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Funciones para manejar las solicitudes

const getDatos= async () => {
  try {
    const response = await api.get('stockDeposito');
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};

const getStockDeposito = async (codigo) => {
  try {
    const response = await api.get(`stockDeposito`, { params: { codigo } }); // Agrega el código como parámetro de consulta
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};

const getOneDatos = async (id) => {
  try {
    const response = await api.get(`garden/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};

const PostDatos = async (datos) => {
  try {
    const response = await api.post('stockDeposito', datos);
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error('Error al enviar datos al backend: ' + error.response.data.message);
    } else {
      throw new Error('Error al enviar datos al backend: ' + error.message);
    }
  }
};

const PostDatosDevolucion = async (datos) => {
  try {
    const response = await api.post('stockDepositoDevolucion', datos);
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error('Error al enviar datos al backend: ' + error.response.data.message);
    } else {
      throw new Error('Error al enviar datos al backend: ' + error.message);
    }
  }
};

const getOneTicket = async (id) => {
  try {
    const response = await api.get(`getOneTicketDeposito/${id}`); 
    return response.data;
  } catch (error) {
    console.error('Error al obtener productos tejidos:', error);
    throw error;
  }
};

const getOneHistorialTicket = async (id) => {
  try {
    const response = await api.get(`getOneHistorialDeposito/${id}`); 
    return response.data;
  } catch (error) {
    console.error('Error al obtener productos tejidos:', error);
    throw error;
  }
}

export { getDatos, PostDatos, getOneDatos, getStockDeposito, getOneTicket, PostDatosDevolucion, getOneHistorialTicket };
